import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'
import HrbTranslate from '../../language/HrbTranslate';
import "./Pages.scss";

const PreviousPage = ({ currentPage, onSetPage }) => (
    <div className={classnames('prev', { 'disabled': currentPage === 0 })} onClick={() => onSetPage(Math.max(0, currentPage - 1))}>
        <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 1L2 9L10 17" stroke="#007C10" strokeWidth="2" />
        </svg>

        {currentPage !== 0 &&
            <a><HrbTranslate text="QueuePage.Labels.Prev" /></a>
        }
        {currentPage === 0 && 
            <HrbTranslate text="QueuePage.Labels.Prev" />
        }
    </div>
)


PreviousPage.propTypes = {
    currentPage: PropTypes.number.isRequired,
    onSetPage: PropTypes.func.isRequired
}

export default PreviousPage;